import React from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

// Shared components
import {
  Instructions,
  Message,
  Icon,
  Label,
  TextArea as TextAreaField
} from './Components';

const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  padding-bottom: ${({ isInvalid }) => (isInvalid ? '0.25rem' : '0')};
`;

const TextAreaWrapper = styled.div`
  position: relative;
`;

const Counter = styled.div`
  font-size: 0.75rem;
  position: absolute;
  bottom: 0.5rem;
  right: 0.75rem;
`;

export default function TextArea({
  type = 'textarea',
  label = null,
  errors = [],
  isValid = null,
  isInvalid = null,
  counterValue = null,
  instructions = '',
  ...props
}) {
  const id = uuid();
  const errorId = uuid();

  const error = errors && errors.length > 0;
  const liveMessage = error ? errors[0] : '';

  return (
    <Wrapper isInvalid={isInvalid}>
      <Icon isValid={isValid && props.value} />
      <Label
        isEmpty={!props.value && !props.defaultValue}
        isInvalid={isInvalid}
        htmlFor={id}
      >
        {label || props.placeholder}
      </Label>
      <TextAreaWrapper>
        <TextAreaField
          isEmpty={!props.value && !props.defaultValue}
          isValid={isValid && props.value}
          isInvalid={isInvalid}
          type={type}
          {...props}
          id={id}
          aria-invalid={error}
          aria-describedby={errorId}
        />
        {counterValue && <Counter>{counterValue}</Counter>}
      </TextAreaWrapper>
      {error && (
        <Message
          className="text-area__message"
          id={errorId}
          role="alert"
          isInvalid={isInvalid}
        >
          {liveMessage}
        </Message>
      )}
      {instructions ? <Instructions>{instructions}</Instructions> : null}
    </Wrapper>
  );
}
